// MainFormDigi.jsx

import React, { useState } from "react";
import "./style.css";
import "../../assets/css/candidate-tab-form.css";
import Education3 from "./Education3";
import DigilockerPopup from "./digilockerPopup";

const MainFormDigi = () => {
  const [showDigilockerPopup, setShowDigilockerPopup] = useState(false);

  const handleContinue = () => {
    // Show the DigilockerPopup
    setShowDigilockerPopup(true);
  };

  const value = {
    // Define your value object here
    // For example:
    school: "Your School Name",
    degree: "Your Degree",
    fieldOfStudy: "Your Field of Study",
    startDate: "Your Start Date",
    endDate: "Your End Date",
  };

  return (
    <>
      <div className="container-fluid w-100 p-2">
        <div className="headSection">
          <div className="d-flex justify-content-between align-items-start px-3">
            <div className="headings">
              <div className="head">Education</div>
              <div className="subHead">
                Add your highest education degree/certificate/all marksheets
              </div>
            </div>
          </div>
          <div className="row p-0 m-0">
            <div className="col-lg-8 col-md-12 col-sm-12 info-section m-3">
              {/* <div className="info-head">Follow the instructions</div>
              <p>
                <ol>
                  <li>
                    Select Documents:
                    <ul>
                      <li>
                        Choose both "degree certificate" and "marksheet" (if
                        available in options) for UG/PG degrees.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Complete All Fields:
                    <ul>
                      <li>
                        After selecting document types, new fields will appear.
                      </li>
                      <li>
                        Fill in all these fields accurately. This information is
                        essential for DigiLocker to find your documents.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Add All Semesters details:
                    <ul>
                      <li>
                        To get marksheets from every semester/year, use the "Add
                        More" button and enter details for each.
                      </li>
                    </ul>
                  </li>
                </ol>
              </p> */}
               <div className="info-head">Instructions: You will now be redirected to Digilocker for fetching your Education Documents</div>
              <p style={{fontSize: 14}}>
                <ol>
                  <li>
                  Select Documents and Choose both "degree certificate" and "marksheet" (if available in options) for UG/PG degrees
                  </li>
                  <li>
                  Complete All Fields: Enter the required details. This information is essential for fetching Data
                  </li>
                  <li>
                  Add All Semesters details: Use the "Add More" button and enter details for each semester
                  </li>
                </ol>
              </p>
            </div>
          </div>
          <Education3 value={value} />
          <Education3 value={value} />

          {/* Continue button */}
          <div className="col-12 py-3">
            <button className="btn btn-primary" onClick={handleContinue}>
              Fetch Document Via Digilocker
            </button>
          </div>
        </div>

        {/* DigilockerPopup */}
        {showDigilockerPopup && (
          <DigilockerPopup
            closePopup={() => setShowDigilockerPopup(false)}
            handleSaveData={() => {
              // Implement your logic to handle saving data
              setShowDigilockerPopup(false); // Close the popup after saving data
            }}
          />
        )}
      </div>
    </>
  );
};

export default MainFormDigi;
